/**
 * Component: Group Size
 */
(() => {
  const DEFAULT_MIN = 2;
  const DEFAULT_MAX = 24;
  const GROUP_SIZE_CHANGE_EVENT = 'group-size:change';

  class ProductGroupSize extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.group-size__value');
      this.stepButtons = this.querySelectorAll('[data-group-size-step]');
      this.maxNotice = (this.closest('.group-size') || document).querySelector('[data-group-size-max-notice]');
      this.min = parseInt(this.dataset.min, 10) || DEFAULT_MIN;
      this.max = parseInt(this.dataset.max, 10) || DEFAULT_MAX;
    }

    connectedCallback() {
      if (!this.input) return;
      this.stepButtons.forEach((button) => {
        button.addEventListener('click', this.handleStep.bind(this));
      });
      this.updateButtons();
      this.updateMaxNotice();
    }

    handleStep(event) {
      const delta = parseInt(event.currentTarget.dataset.groupSizeStep, 10);
      const current = parseInt(this.input.value, 10) || this.min;
      const next = Math.min(this.max, Math.max(this.min, current + delta));

      if (next === current) return;

      this.input.value = next;
      this.updateButtons();
      this.updateMaxNotice();
      this.dispatchChange(next);
    }

    dispatchChange(value) {
      this.dispatchEvent(new CustomEvent(GROUP_SIZE_CHANGE_EVENT, {
        bubbles: true,
        detail: { value },
      }));
    }

    updateButtons() {
      const value = parseInt(this.input.value, 10) || this.min;
      this.stepButtons.forEach((button) => {
        const delta = parseInt(button.dataset.groupSizeStep, 10);
        const projected = value + delta;
        button.disabled = projected < this.min || projected > this.max;
      });
    }

    updateMaxNotice() {
      if (!this.maxNotice) return;
      const value = parseInt(this.input.value, 10) || this.min;
      this.maxNotice.hidden = value < this.max;
    }
  }

  customElements.define('product-group-size', ProductGroupSize);
})();
